import { render, staticRenderFns } from "./Authority.vue?vue&type=template&id=1f3dfc94&scoped=true&"
import script from "./Authority.vue?vue&type=script&lang=js&"
export * from "./Authority.vue?vue&type=script&lang=js&"
import style0 from "./Authority.vue?vue&type=style&index=0&id=1f3dfc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3dfc94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3dfc94')) {
      api.createRecord('1f3dfc94', component.options)
    } else {
      api.reload('1f3dfc94', component.options)
    }
    module.hot.accept("./Authority.vue?vue&type=template&id=1f3dfc94&scoped=true&", function () {
      api.rerender('1f3dfc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roleComponents/Authority.vue"
export default component.exports